"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareNameForValidate = void 0;

var prepareNameForValidate = function prepareNameForValidate(name) {
  return name.replace(/.items./g, '.').replace(/.fields./g, '.');
};

exports.prepareNameForValidate = prepareNameForValidate;